/**
 * Custom sorting by Launch Date metafield
 * Handles sorting products by custom.launch_date metafield values
 */

(function() {
  'use strict';

  console.log('🔧 Launch Date Sort Script Loaded');

  let currentSortType = null;

  // Listen for sort changes on the custom select element
  const customSelect = document.getElementById('products-sort-by');
  
  if (!customSelect) {
    console.error('❌ Custom select not found!');
    return;
  }

  // Listen to the custom select component's change event
  customSelect.addEventListener('change', function(e) {
    const selectedValue = e.detail?.selectedValue || e.target.value;
    
    if (selectedValue === 'custom.launch_date_desc' || selectedValue === 'custom.launch_date_asc') {
      console.log('🛑 Preventing form submission for custom sort');
      
      // Prevent the form from submitting
      e.stopPropagation();
      e.preventDefault();
      
      // Update URL without page reload
      const url = new URL(window.location);
      url.searchParams.set('sort_by', selectedValue);
      window.history.pushState({}, '', url);
      
      currentSortType = selectedValue;
      sortByLaunchDate(selectedValue);
    } else {
      currentSortType = null;
      // Reset any custom order styling
      resetProductOrder();
      // Allow normal form submission for other sort options
    }
  });

  // Also intercept native select form submission
  const facetsForm = document.getElementById('facets');
  if (facetsForm) {
    facetsForm.addEventListener('submit', function(e) {
      const nativeSelect = document.querySelector('select[name="sort_by"]');
      const selectedValue = nativeSelect?.value;
      
      if (selectedValue === 'custom.launch_date_desc' || selectedValue === 'custom.launch_date_asc') {
        console.log('🛑 Preventing form submission for custom sort (native)');
        e.preventDefault();
        e.stopPropagation();
        
        // Update URL without page reload
        const url = new URL(window.location);
        url.searchParams.set('sort_by', selectedValue);
        window.history.pushState({}, '', url);
        
        currentSortType = selectedValue;
        sortByLaunchDate(selectedValue);
      }
    });
  }

  // Check if the page loaded with a custom sort parameter
  function checkInitialSort() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    
    if (sortBy === 'custom.launch_date_desc' || sortBy === 'custom.launch_date_asc') {
      currentSortType = sortBy;
      // Delay to ensure DOM is ready
      setTimeout(() => sortByLaunchDate(sortBy), 100);
    }
  }

  // Run initial sort check after page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkInitialSort);
  } else {
    checkInitialSort();
  }

  function resetProductOrder() {
    const gridContainer = document.querySelector('.main-products-grid__results ul.grid');
    if (!gridContainer) return;
    
    const products = gridContainer.querySelectorAll('li.js-pagination-result');
    products.forEach(li => {
      li.style.order = '';
    });
  }

  function sortByLaunchDate(sortType) {
    console.log('🚀 Starting sort:', sortType);
    
    // Find the grid container - it's inside .main-products-grid__results
    const gridContainer = document.querySelector('.main-products-grid__results ul.grid');
    
    if (!gridContainer) {
      console.error('❌ Grid container not found!');
      return;
    }

    console.log('✅ Grid container found:', gridContainer);

    // Get all li elements with class js-pagination-result
    const allItems = Array.from(gridContainer.querySelectorAll('li.js-pagination-result'));
    
    console.log(`🔍 Found ${allItems.length} items total`);

    // Separate products from promos
    const productsWithData = [];
    const promoItems = [];
    
    allItems.forEach((li, idx) => {
      const productCard = li.querySelector('product-card');
      
      if (productCard) {
        const launchDateAttr = productCard.getAttribute('data-launch-date');
        const launchDate = parseInt(launchDateAttr || '0', 10);
        
        productsWithData.push({
          element: li,
          date: launchDate,
          originalIndex: idx
        });
        
        console.log(`📦 Product ${productsWithData.length}: date=${launchDate} (${launchDateAttr})`);
      } else {
        promoItems.push({ element: li, originalIndex: idx });
        console.log(`🎁 Promo at index ${idx}`);
      }
    });

    if (productsWithData.length === 0) {
      console.error('❌ No products found!');
      return;
    }

    console.log(`✅ Found ${productsWithData.length} products, ${promoItems.length} promos`);
    console.log('📊 Before sort:', productsWithData.map(p => p.date));

    // Sort products by launch date
    productsWithData.sort((a, b) => {
      if (sortType === 'custom.launch_date_desc') {
        return b.date - a.date; // Newest first
      } else {
        return a.date - b.date; // Oldest first
      }
    });

    console.log('📊 After sort:', productsWithData.map(p => p.date));

    // Method: Use CSS Grid order property
    // This works because the ul has class="grid"
    console.log('🎨 Applying CSS order...');
    
    let orderIndex = 0;
    
    // Apply order to sorted products
    productsWithData.forEach((item) => {
      item.element.style.order = orderIndex;
      console.log(`Set order ${orderIndex} for product with date ${item.date}`);
      orderIndex++;
    });
    
    // Apply order to promos to keep them at the end
    promoItems.forEach((item) => {
      item.element.style.order = orderIndex;
      orderIndex++;
    });

    console.log('✅ Sort complete!');
  }
})();

